import React from "react";

import { Tag } from "clearsense-ui/components";

import {
  STATUS_TAG_COLORS,
  STATUS_TAG_LABELS,
  STATUS_TAG_ICONS,
} from "./constants";

const StatusTag = ({ status }) => (
  <Tag
    color={STATUS_TAG_COLORS[status]}
    label={STATUS_TAG_LABELS[status] ?? status}
    icon={STATUS_TAG_ICONS[status] ?? undefined}
    data-cy="connection-status-tag"
    className="capitalize"
  />
);

export default StatusTag;
